<template>
  <div class="p-grid p-col-12">
    <div class="p-col-12 p-md-3 p-lg-4 no-padding-margin-bottom-top">

      <card class="p-col-12" :header="$t('protocol.tab-services.services')" >

        <template #actions v-if="loggedUser.typeUser !== limited">
          <a class="small float-right" href @click.prevent="openAddService()"><i class="pi pi-plus-circle small color-primary"/> {{$t('protocol.tab-services.link-add-service')}}</a>
        </template>

        <div class="p-col-12">
          <div class="p-mt-2"><span class="p-mr-1 bold">{{$t('forms.protocol.type-service')}}:</span>{{protocol.typeService.name}}</div>
          <hr />
          <div class="p-mt-2">
            <display-protocol-service :protocol="protocol" class="p-mt-2"/>
          </div>
        </div>
      </card>

      <card class="p-col-12 force-mb-0" :header="$t('protocol.tab-services.clients')">

        <template #actions v-if="loggedUser.typeUser !== limited">
          <a class="small float-right" href @click.prevent="openAddClient()"><i class="pi pi-plus-circle small color-primary"/> {{$t('protocol.tab-services.link-add-client')}}</a>
        </template>

        <div class="p-col-12">
          <div class="p-mt-2"><span class="p-mr-1 bold">{{$t('forms.protocol.main-client')}}:</span><a class="cursor-pointer" :href="`#/client/${protocol.mainClient.id}/details`">{{protocol.mainClient.name}}</a></div>
          <hr />
          <div class="p-mt-2">
            <display-protocol-client :protocol="protocol" class="p-mt-2"/>
          </div>
        </div>

      </card>

    </div>
    <div class="p-col-12 p-md-9 p-lg-8 no-padding-margin-bottom-top" id="editor">

      <component :protocol="protocol" :param-component="componentEditor.paramComponent" :is="componentEditor.currentComponent" ref="comp" @success="componentEditor.callBack"/>

    </div>

  </div>
</template>

<script>

import DisplayProtocolService from "@/viewer/protocol/tabs/services/DisplayProtocolService";
import DisplayProtocolClient from "@/viewer/protocol/tabs/services/DisplayProtocolClient";
import EventBus from "@/commons/EventBus";
import store from "@/store";
import {LIMITED} from "@/constants/TypeUser";

export default {
  name: "TabServicesProtocol",
  components: {DisplayProtocolClient, DisplayProtocolService},
  props:{
    protocol: {type: Object, default: () => {return {}}},
  },

  beforeMount() {
    EventBus.$on('CHANGE_COMPONENT_EDITOR', this.changeComponentEditor);
  },

  beforeDestroy(){
    EventBus.$off('CHANGE_COMPONENT_EDITOR', this.changeComponentEditor);
  },

  data(){
    return {
      limited: LIMITED,
      loggedUser: store.getLoggedUser(),
      componentEditor: {
        currentComponent: null,
        paramComponent: null,
        callBack: () => {},
      },
    }
  },

  methods:{

    closeCurrentComponent(){
      this.componentEditor.currentComponent = null;
      this.componentEditor.paramComponent = null;
    },

    changeComponentEditor(componentEditor){
      this.closeCurrentComponent();
      setTimeout(() => {
        this.$set(this, 'componentEditor', componentEditor);
        setTimeout(() => {
          const el = this.$el.querySelector("#editor");
          el.scrollIntoView({behavior: 'smooth', block: "center"});
        }, 5);
      }, 10);
    },

    openAddService(){
      EventBus.$emit('OPEN_ADD_SERVICE_PROTOCOL');
    },

    openAddClient(){
      EventBus.$emit('OPEN_ADD_CLIENT_PROTOCOL');
    },

  }

}
</script>

<style scoped>
  .no-padding-margin-bottom-top {
    padding-top: 0 !important;
    margin-top: 0 !important;
    padding-bottom: 0 !important;
    margin-bottom: 0 !important;
  }

  .force-mb-0 {
    margin-bottom: 0rem !important;
  }

  .force-mt-0 {
    margin-bottom: 0rem !important;
  }

</style>